import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=678842b0&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678842b0",
  null
  
)

export default component.exports